import Icon from "../Icon/Icon";

const DeleteButton = (props) => {
  return (
    <div {...props} className="flex cursor-pointer items-center">
      <Icon className="h-8 w-8 fill-error" variants="times" />
    </div>
  );
};

export default DeleteButton;
